import * as React from 'react';
import '../css/hero.sass';

interface HeroProps {
  bgImg: string;
  name: string;
  tagLine: string;
  children?: React.ReactNode;
}

export default function Hero(props: HeroProps) {
  return (
    <>
      <div className="hero-banner">
        <img className="bg-img" alt={props.name} src={props.bgImg} />
        <div className="pkg-info">
          <h1>{props.name}</h1>
          <p>{props.tagLine}</p>
        </div>
        <div className="credit">{props.children}</div>
      </div>
    </>
  );
}
